import { Navigate, RouteObject } from "react-router-dom";

import { AdminLayout } from "./components/templates";
import { AdminUsersPage } from "./features/users";
import { AdminAccessPage } from "./features/access";
import { AdminComplexesPage } from "./features/complexes";
import { AdminStructuresPage } from "./features/structures";
import { AdminLicenseInventoryPage } from "./features/license-inventory";
import { AdminLicenseAssignmentsPage } from "./features/license-assignments";
import { AdminPermissionsPage } from "./features/permissions";

export const adminRoutes: RouteObject[] = [
  {
    path: "",
    element: <AdminLayout />,
    children: [
      {
        index: true,
        element: <Navigate to="users" replace />,
      },
      {
        path: "users",
        element: <AdminUsersPage />,
      },
      {
        path: "access",
        element: <AdminAccessPage />,
      },
      {
        path: "complexes",
        element: <AdminComplexesPage />,
      },
      {
        path: "structures",
        element: <AdminStructuresPage />,
      },
      {
        path: "license-inventory",
        element: <AdminLicenseInventoryPage />,
      },
      {
        path: "license-assignments",
        element: <AdminLicenseAssignmentsPage />,
      },
      {
        path: "permissions",
        element: <AdminPermissionsPage />,
      },
    ],
  },
];
